import { SITE_URL } from "@/lib/site";

const waShare = (label, path) =>
  `https://wa.me/?text=${encodeURIComponent(`Check out the ${label} from Cool Runnings: ` + SITE_URL + path)}`;

// Share a real PDF file to WhatsApp: hands the document to the phone's share sheet
// (WhatsApp attaches the file itself). Falls back to a plain wa.me link where
// file sharing is not supported (most desktop browsers).
export const sharePdfOnWhatsApp = async (label, path) => {
  const fallback = () => window.open(waShare(label, path), "_blank", "noopener,noreferrer");
  try {
    const res = await fetch(path);
    if (!res.ok) return fallback();
    const blob = await res.blob();
    const file = new File([blob], path.split("/").pop() || "cool-runnings.pdf", { type: "application/pdf" });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title: label, text: `${label} from Cool Runnings` });
    } else {
      fallback();
    }
  } catch (err) {
    if (err && err.name !== "AbortError") fallback();
  }
};